import React from 'react';
import './Footer.css';

import { Logo, Heading } from '../../components';
import { contactContent, services } from '../../constants';

import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin, FaAngleDoubleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';


  
const Footer = () => {   
    
  return (
    <footer className='footer'>
      
      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'> 
          <Logo />
          <p>貓頭鷹的日文叫做ふくろう，發音「FUKURO」與「不苦勞」一樣， 所以被當做吉祥物，受到歡迎。 因爲購物之後還要折抵和繳停車費對於銀髮長者、行動不便的朋友和為家務操勞的媽媽們總是很辛苦，為了讓大家都免於苦勞，所以推出了「FUKURO」，特別用貓頭鷹作為本服務吉祥物。</p>
          <p>FUKURO 聰明停車服務旨在提供便利性，將賣場購物折抵與停車費支付整合，讓購物停車繳費免排隊也免操作，也讓顧客擁有更便利的選擇。</p>
          <div className='social'>
            <a href="https://www.facebook.com/10parking"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>
        </div> 

        {/* Services Links Section */}
        <div className='footer-item'> 

          <Heading title={'方便貼心的服務'} />

          <div className='info links'> 
           
            {services.map(service => {

              {/* Link to the individual service page */}
              
              return <p key={service.id}><FaAngleDoubleRight className='icon' /> <Link
                to={{ 
                  pathname: '/Services/' + service.title,
                }}
                location = {{service}}
                state= {service}>{service.title}  {/* Service Title */}
              </Link>
              </p>
            })}

          </div>
        </div> 

        {/* Useful Links Section */}
        {/* <div className='footer-item'> 

          <Heading title={'useful links'} />

          <div className='info links'> 
              <p><FaAngleDoubleRight className='icon' /><Link to='/about-us'>about</Link></p>
              <p><FaAngleDoubleRight className='icon' /><Link to='/Services'>Services</Link></p>
              <p><FaAngleDoubleRight className='icon' /><Link to='/Projects'>Projects</Link></p>
              <p><FaAngleDoubleRight className='icon' /><Link to='/Blog-list'>blogs</Link></p>
              <p><FaAngleDoubleRight className='icon' /><Link to='/Shop-list'>shop</Link></p>
              <p><FaAngleDoubleRight className='icon' /><Link to='/Contact-us'>contact</Link></p>
          </div>

        </div>  */}
  
        {/* Contact Info Section */}
        <div className='footer-item'>  

          <Heading title={'順康資產管理顧問有限公司'} />

          <div className='info connect'> 
            {contactContent.map((contact) => {
              return (contact.content).map((value, index) => {
                return <p key={index}><span className='icon'>{contact.icon}</span>{value}</p>
              })
            })}
          </div>
 
        </div>

      </div>
 
      <div className='content'>
        <p>&copy; 2024 - <span>順康資產管理顧問有限公司</span> | 開發與維護</p>
      </div>
      
    </footer>
  )
}

export default Footer;